// extracted by mini-css-extract-plugin
module.exports = {"barChartWrapper":"style__barChartWrapper__x8skK","bars":"style__bars__5thy1","legendBox":"style__legendBox__yFGx7"};